export const EMPTY_PROCESS_LABEL = "Processes Not Initialised";

export const getNestedValue = (row: any, item: any) => {
  if (item.nestedColumnName) {
    if (item.nestedType === "object") {
      const value = row[item.name]?.[item.nestedColumnName];
      // If process value is empty, match Figma empty-state copy.
      if (item.name === "process" && !value) {
        return EMPTY_PROCESS_LABEL;
      }
      return value;
    } else if (item.nestedType === "array") {
      if (!row[item.name] || !Array.isArray(row[item.name])) {
        return "";
      }
      return row[item.name]
        .map((subItem: any) => subItem[item.nestedColumnName])
        .join(", ");
    }
  }

  const value = row[item.name];
  // If process value is empty, match Figma empty-state copy.
  if (item.name === "process" && !value) {
    return EMPTY_PROCESS_LABEL;
  }
  return value || "";
};

export const renderCell = (cellInfo: any, item: any) => {
  const { row } = cellInfo;

  return getNestedValue(row.original, item);
};
